import { OutcomeType, DispositionReasonType, DispositionSpecificationType } from '@/api/apis/case';
import { dispositionReasonsNames, dispositionSpecificationNames } from '@/constants/case/case.constants';

export const defaultValues = {
  declineReason: OutcomeType.Aborted,
  dispositionReason: DispositionReasonType.OrganNotSuitableForOCS,
  dispositionSpecification: DispositionSpecificationType.None,
  turndownOutcome: '',
  dispositionComment: '',
  timeZone: '',
  timestamp: '',
};

export const CancelationReasons = [
  {
    value: DispositionReasonType.OrganNotSuitableForOCS,
    name: dispositionReasonsNames[DispositionReasonType.OrganNotSuitableForOCS],
  },
];
export const Specifications = [
  { value: DispositionSpecificationType.None, name: dispositionSpecificationNames[DispositionSpecificationType.None] },
];
